export const formatoCertificado = `<!DOCTYPE html>
<html lang="es">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">

    <title>Certificación de Servicio - DASOFT SRL</title>

    <style>
        * {
            box-sizing: border-box;
        }

        html,
        body {
            margin: 0;
            padding: 0;
            background: #eef1f5;
            font-family: "Segoe UI", Arial, Helvetica, sans-serif;
            color: #202733;
        }

        /*
        ============================================================
        FORMATO CARTA
        8.5 x 11 pulgadas
        ============================================================
        */

        .document {
            width: 8.5in;
            height: 11in;
            margin: 20px auto;
            background: #ffffff;

            padding: 0.55in 0.65in 0.55in 0.65in;

            position: relative;

            box-shadow: 0 5px 25px rgba(0, 0, 0, .10);

            overflow: hidden;
        }


        /*
        ============================================================
        HEADER
        ============================================================
        */

        .header {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;

            padding-bottom: 12px;

            border-bottom: 3px solid #17365d;
        }

        .company {
            display: flex;
            align-items: center;
            gap: 11px;
        }

        .logo {
            width: 130px;
            height: 48px;

 
             color: #ffffff;

            display: flex;
            align-items: center;
            justify-content: center;

 
            letter-spacing: -1px;
        }

        .company-name {
            font-size: 15px;
            font-weight: 800;

            color: #17365d;
        }

        .company-subtitle {
            font-size: 9px;
            color: #6b7280;

            margin-top: 3px;
        }

        .certificate-info {
            text-align: right;

            font-size: 8.5px;
            color: #6b7280;

            line-height: 1.5;
        }

        .certificate-number {
            color: #17365d;
            font-weight: 800;
        }


        /*
        ============================================================
        TITLE
        ============================================================
        */

        .title-section {
            text-align: center;

            margin: 17px 0 13px;
        }

        .title {
            margin: 0;

            font-size: 19px;
            font-weight: 800;

            color: #17365d;

            letter-spacing: .4px;
        }

        .title-line {
            width: 48px;
            height: 3px;

            background: #2f75b5;

            margin: 7px auto 0;

            border-radius: 5px;
        }


        /*
        ============================================================
        INTRO
        ============================================================
        */

        .intro {
            font-size: 9.5px;
            line-height: 1.5;

            text-align: justify;

            margin: 0 0 13px;
        }


        /*
        ============================================================
        SECTIONS
        ============================================================
        */

        .section {
            margin-top: 12px;
        }

        .section-title {
            display: flex;
            align-items: center;

            gap: 7px;

            margin-bottom: 6px;

            color: #17365d;

            font-size: 10px;
            font-weight: 800;

            text-transform: uppercase;

            letter-spacing: .3px;
        }

        .section-title::before {
            content: "";

            width: 3px;
            height: 14px;

            background: #2f75b5;

            border-radius: 3px;
        }


        /*
        ============================================================
        CLIENT DATA
        ============================================================
        */

        .client-box {
            border: 1px solid #dce2e8;

            border-radius: 6px;

            overflow: hidden;
        }

        .client-row {
            display: flex;

            border-bottom: 1px solid #e6e9ed;
        }

        .client-row:last-child {
            border-bottom: none;
        }

        .client-item {
            width: 50%;

            padding: 7px 10px;
        }

        .client-item.full {
            width: 100%;
        }

        .client-item + .client-item {
            border-left: 1px solid #e6e9ed;
        }

        .label {
            font-size: 7.5px;

            color: #78818d;

            text-transform: uppercase;

            font-weight: 700;

            margin-bottom: 2px;
        }

        .value {
            font-size: 9.5px;

            font-weight: 600;

            color: #202733;
        }


        /*
        ============================================================
        SERVICE TABLE
        ============================================================
        */

        .service-table {
            width: 100%;

            border-collapse: collapse;

            border: 1px solid #dce2e8;

            border-radius: 6px;

            overflow: hidden;
        }

        .service-table th {
            background: #17365d;

            color: white;

            padding: 7px 10px;

            text-align: left;

            font-size: 8px;

            text-transform: uppercase;

            letter-spacing: .3px;
        }

        .service-table td {
            padding: 7px 10px;

            border-bottom: 1px solid #e6e9ed;

            font-size: 9.5px;
        }

        .service-table tr:last-child td {
            border-bottom: none;
        }

        .service-table td:last-child {
            text-align: right;

            font-weight: 700;
        }

        .highlight {
            background: #f3f7fb;
        }

        .amount {
            font-size: 13px;

            color: #17365d;

            font-weight: 800;
        }


        /*
        ============================================================
        RESPONSABILIDAD
        ============================================================
        */

        .responsibility {
            background: #f7f9fb;

            border: 1px solid #e0e5ea;

            border-left: 3px solid #17365d;

            padding: 8px 10px;

            border-radius: 5px;
        }

        .responsibility p {
            font-size: 8.7px;

            line-height: 1.45;

            margin: 0 0 5px;

            text-align: justify;
        }

        .responsibility ol {
            margin: 5px 0 0 16px;

            padding: 0;
        }

        .responsibility li {
            font-size: 8.4px;

            line-height: 1.35;

            margin-bottom: 3px;
        }


        /*
        ============================================================
        TEXT
        ============================================================
        */

        .certification-text {
            font-size: 8.8px;

            line-height: 1.48;

            text-align: justify;

            margin: 0;
        }


        /*
        ============================================================
        SIGNATURE
        ============================================================
        */

        .signature-area {
            margin-top: 20px;

            display: flex;

            justify-content: space-between;

            gap: 60px;
        }

        .signature {
            width: 42%;

            text-align: center;
        }

        .signature-space {
            height: 25px;
        }

        .signature-line {
            border-top: 1px solid #333;

            margin-bottom: 5px;
        }

        .signature-name {
            font-size: 8.8px;

            font-weight: 800;

            color: #17365d;
        }

        .signature-role {
            font-size: 7.8px;

            color: #6b7280;

            margin-top: 2px;

            line-height: 1.35;
        }


        /*
        ============================================================
        FOOTER
        ============================================================
        */

        .footer {
            position: absolute;

            left: 0.65in;
            right: 0.65in;

            bottom: 0.27in;

            border-top: 1px solid #dce2e8;

            padding-top: 5px;

            display: flex;

            justify-content: space-between;

            font-size: 7px;

            color: #7a828c;
        }

        .footer strong {
            color: #17365d;
        }


        /*
        ============================================================
        PRINT
        ============================================================
        */

        @media print {

            html,
            body {
                background: #ffffff;
            }

            .document {
                width: 8.5in;
                height: 11in;

                margin: 0;

                padding: 0.55in 0.65in 0.55in 0.65in;

                box-shadow: none;

                page-break-after: always;
            }

            @page {
                size: Letter portrait;
                margin: 0;
            }
        }

    </style>
</head>


<body>

<div class="document">


    <!-- ========================================================
         HEADER
    ========================================================= -->

    <header class="header">

        <div class="company">

                
            <img
                src="https://www.dasoft.com.do/wp-content/themes/dasoft2.0/image/dasoft-logo.png"
                 alt="Sello oficial DASOFT SRL"
                class="logo"
            >
 
            <div>

                <div class="company-name">
                    D’ÁNGEL SOFTWARE ELECTRONIC, S.R.L.
                </div>

                <div class="company-subtitle">
                    DASOFT SRL · Soluciones Tecnológicas Empresariales
                </div>

            </div>

        </div>


        <div class="certificate-info">

            <div class="certificate-number">
                CERTIFICACIÓN No. {certificacion}
            </div>

            <div>
                Fecha de emisión: {fecha}
            </div>

        </div>

    </header>



    <!-- ========================================================
         TITLE
    ========================================================= -->

    <section class="title-section">

        <h1 class="title">
            CERTIFICACIÓN DE SERVICIO
        </h1>

        <div class="title-line"></div>

    </section>



    <!-- ========================================================
         INTRO
    ========================================================= -->

    <p class="intro">

        Por medio de la presente, <strong>D’ÁNGEL SOFTWARE ELECTRONIC,
        S.R.L. (DASOFT SRL)</strong>, certifica que el cliente identificado
        a continuación mantiene contratado con nuestra empresa el servicio
        tecnológico de <strong>API para Facturación Electrónica</strong>,
        bajo las condiciones comerciales y técnicas indicadas en la presente
        certificación.

    </p>



    <!-- ========================================================
         CLIENTE
    ========================================================= -->

    <section class="section">

        <div class="section-title">
            Información del Cliente
        </div>


        <div class="client-box">


            <div class="client-row">

                <div class="client-item">

                    <div class="label">
                        RNC
                    </div>

                    <div class="value">
                        {rnc}
                    </div>

                </div>


                <div class="client-item">

                    <div class="label">
                        Nombre / Razón Social
                    </div>

                    <div class="value">
                        {nombre}
                    </div>

                </div>

            </div>



            <div class="client-row">

                <div class="client-item full">

                    <div class="label">
                        Dirección
                    </div>

                    <div class="value">
                        {direccion}
                    </div>

                </div>

            </div>



            <div class="client-row">

                <div class="client-item full">

                    <div class="label">
                        Correo Electrónico
                    </div>

                    <div class="value">
                        {email}
                    </div>

                </div>

            </div>


        </div>

    </section>



    <!-- ========================================================
         SERVICIO
    ========================================================= -->

    <section class="section">

        <div class="section-title">
            Condiciones del Servicio
        </div>


        <table class="service-table">

            <thead>

                <tr>

                    <th>
                        Concepto
                    </th>

                    <th>
                        Condición Contratada
                    </th>

                </tr>

            </thead>


            <tbody>

                <tr>

                    <td>
                        Servicio
                    </td>

                    <td>
                        {servicio}
                    </td>

                </tr>


                <tr class="highlight">

                    <td>
                        Cantidad de documentos contratados
                    </td>

                    <td>
                        {cantidad} documentos mensuales
                    </td>

                </tr>


                <tr>

                    <td>
                        Frecuencia de facturación
                    </td>

                    <td>
                       La facturación se realiza anticipadamente el día 20 de cada mes, correspondiente al Periodo siguiente.
                    </td>

                </tr>


                <tr class="highlight">

                    <td>
                        Facturación mensual
                    </td>

                    <td class="amount">
                        RD$ {monto}
                    </td>

                </tr>
                <tr class="highlight">

                    <td>
                        Certificado Valido Hasta
                    </td>

                    <td class="amount">
                         {valid_certificado}
                    </td>

                </tr>

            </tbody>

        </table>

    </section>



    <!-- ========================================================
         CONSTANCIA
    ========================================================= -->

    <section class="section">

        <div class="section-title">
            Constancia del Servicio
        </div>


        <p class="certification-text">

            DASOFT SRL certifica que la cantidad de documentos electrónicos
            indicada corresponde al límite mensual contratado por el cliente
            para el servicio de API para Facturación Electrónica.

            El monto de <strong>RD$ {monto}</strong> corresponde a la
            facturación mensual del servicio, conforme a las condiciones
            comerciales acordadas entre DASOFT SRL y el cliente.

            La prestación del servicio se encuentra sujeta a las condiciones
            técnicas, comerciales y legales aplicables al servicio contratado.

        </p>

    </section>



    <!-- ========================================================
         RESPONSABILIDAD DEL CLIENTE
    ========================================================= -->

    <section class="section">

        <div class="section-title">
            Responsabilidad del Cliente
        </div>


        <div class="responsibility">


            <p>

                El cliente reconoce y acepta que DASOFT SRL proporciona una
                herramienta tecnológica destinada a facilitar la integración
                y transmisión de documentos electrónicos. Por tanto,
                <strong>el cliente mantiene la responsabilidad sobre la
                información que genere, suministre y transmita mediante
                el servicio.</strong>

            </p>


            <ol>

                <li>
                    La veracidad, exactitud, integridad y legitimidad de la
                    información utilizada en sus documentos electrónicos.
                </li>

                <li>
                    La correcta configuración de sus datos fiscales,
                    comerciales y tributarios.
                </li>

                <li>
                    Mantener vigente el certificado de firma electrónica
                    requerido para la emisión de documentos electrónicos,
                    cuando corresponda.
                </li>

                <li>
                    El uso adecuado de las credenciales, usuarios y
                    mecanismos de acceso proporcionados por DASOFT SRL.
                </li>

                <li>
                    El cumplimiento de las obligaciones tributarias y
                    disposiciones establecidas por la DGII.
                </li>

                <li>
                    La revisión y validación de la información contenida
                    en los documentos antes de su emisión o transmisión.
                </li>

            </ol>


        </div>

    </section>



    <!-- ========================================================
         RESPONSABILIDAD DASOFT
    ========================================================= -->

    <section class="section">

        <div class="section-title">
            Responsabilidad de DASOFT SRL
        </div>


        <p class="certification-text">

            DASOFT SRL será responsable de proporcionar el servicio
            tecnológico contratado y mantener, dentro de su ámbito de
            control, los mecanismos tecnológicos necesarios para su
            prestación.

            DASOFT SRL no será responsable por errores, inconsistencias,
            rechazos u observaciones originados por información incorrecta,
            incompleta o no conforme con los requisitos establecidos por
            la autoridad fiscal.

            La aprobación, validación o rechazo de los documentos electrónicos
            corresponde exclusivamente a la autoridad fiscal competente,
            conforme a sus procedimientos y normativa vigente.

        </p>

    </section>



    <!-- ========================================================
         CIERRE
    ========================================================= -->

    <section class="section">

        <p class="certification-text">

            Se expide la presente certificación a solicitud del interesado,
            para los fines que estime convenientes, dejando constancia de
            las condiciones comerciales del servicio contratado entre
            <strong>DASOFT SRL</strong> y
            <strong>AGROVETERINARIA ESPINAL SRL</strong>.

        </p>

    </section>



    <!-- ========================================================
         FIRMAS
    ========================================================= -->

    <div class="signature-area">


        <div class="signature">



        </div>



        <div class="signature">

 
             
            <div class="signature-space"></div>

            <div class="signature-line"></div>

            <div class="signature-name">
                ÁNGEL ALEJANDRO CASTILLO GARCÍA
            </div>

            <div class="signature-role">
                Director General de Tecnología<br>
                D’ÁNGEL SOFTWARE ELECTRONIC, S.R.L.
            </div>
         

        </div>


    </div>



    <!-- ========================================================
         FOOTER
    ========================================================= -->

    <footer class="footer">

        <div>
            <strong>DASOFT SRL</strong>
            · Soluciones Tecnológicas Empresariales
        </div>

        <div>
            soporte@coopsys.com.do
        </div>

    </footer>


</div>
<script>window.onload = function(){ window.print(); }<\/script>
</body>
</html>`;


